var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _path9, _path10, _path11, _circle29, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.009 99.8076 167.009C62.6536 167.009 32.5493 137.155 32.5493 100.347C32.5493 63.539 62.6536 33.6853 99.8076 33.6853C136.962 33.6853 167.066 63.539 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.793,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.936,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01221 117.65C7.0667 117.65 7.92153 116.795 7.92153 115.741C7.92153 114.686 7.0667 113.831 6.01221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0317 22.4226C75.0862 22.4226 75.9411 21.5678 75.9411 20.5133C75.9411 19.4588 75.0862 18.604 74.0317 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.279 15.7399 118.424 16.5948 118.424 17.6493C118.424 18.7038 119.279 19.5586 120.333 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0596L172.242 30.0596M162.099 45.8115L162.218 39.6062M150.524 30.0596L148.972 30.0596M162.099 20.7516L162.099 8.57973M166.634 30.0596C163.65 30.0596 162.099 34.3556 162.099 34.3556C162.099 34.3556 161.622 30.0596 157.803 30.0596C159.521 30.0596 161.98 28.5083 162.218 25.4056C162.218 25.4056 162.496 27.9458 163.412 28.8663C164.176 29.6348 166.634 30.0596 166.634 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 49.5,
    width: 75,
    height: 102.5,
    rx: 2,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.8999,
    y: 44,
    width: 32.1,
    height: 10.65,
    rx: 2,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2002,
    y: 65.45,
    width: 9.55,
    height: 9.55,
    rx: 2,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2002,
    y: 85.8,
    width: 9.55,
    height: 9.55,
    rx: 2,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2002,
    y: 106.7,
    width: 9.55,
    height: 9.55,
    rx: 2,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2002,
    y: 127.05,
    width: 9.55,
    height: 9.55,
    rx: 2,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4502 70.5H110.625",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91H111",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78 112H111",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78 132H111",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 99.5,
    r: 24.5,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 91H122.25C121.007 91 120 92.0073 120 93.25V106.75C120 107.993 121.007 109 122.25 109H141.75C142.993 109 144 107.993 144 106.75V93.25C144 92.0073 142.993 91 141.75 91ZM141.75 93.25V95.1627C140.699 96.0186 139.023 97.3495 135.441 100.154C134.652 100.775 133.088 102.267 132 102.25C130.912 102.267 129.348 100.775 128.559 100.154C124.977 97.3499 123.301 96.0188 122.25 95.1627V93.25H141.75ZM122.25 106.75V98.0499C123.324 98.9054 124.847 100.106 127.169 101.924C128.194 102.73 129.988 104.511 132 104.5C134.002 104.511 135.774 102.756 136.831 101.924C139.152 100.106 140.676 98.9055 141.75 98.05V106.75H122.25Z",
    fill: "#194590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLists);
export default __webpack_public_path__ + "static/media/no-lists.981f822daca716bffdf5013c732626d3.svg";
export { ForwardRef as ReactComponent };